<template>
    <SideFormSection :showDivider="true">
        <template #title> Booking Form Theme </template>
        <template #subtitle>
            Customize the appearance of your booking form with the branding
            colors of your business.
        </template>
        <template #rawContent>
            <Card
                title="Booking Form Theme"
                iconName="palette"
            >
                <template #content>
                    <ApiForm
                        :url="RoutePathAppEnum.Company_Update_BookingFormTheme"
                        method="POST"
                        ref="apiFormRef"
                    >
                        <div class="space-y-2">
                            <CompanyDefaultBookingFormThemeForm
                                :company="company"
                                :errors="
                                    apiFormRef?.response?.getErrors() ??
                                    new ApiFormErrors({})
                                "
                            />
                        </div>
                    </ApiForm>
                </template>
                <template #actions>
                    <div class="flex gap-2">
                        <Button
                            as="a"
                            :href="
                                urlFactory.makeCompanyBookingFormUrl(
                                    company.slug,
                                )
                            "
                            target="_blank"
                            iconName="external-link"
                            iconClass="w3.5 h-3.5"
                            color="light"
                        >
                            View
                        </Button>
                        <Button
                            @click="apiFormRef?.submit()"
                            :loading="apiFormRef?.loading.valueOf()"
                            iconName="save"
                            color="dark"
                        >
                            Save
                        </Button>
                    </div>
                </template>
            </Card>
        </template>
    </SideFormSection>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref, type PropType } from 'vue'
    import SideFormSection from '@/Shared/Component/SideFormSection.vue'
    import Button from '@/Shared/Component/Button.vue'
    import Card from '@/Shared/Component/Card.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import Company from '@/App/Company/Entity/Company'
    import CompanyDefaultBookingFormThemeForm from '@/App/Company/Component/CompanyDefaultBookingFormThemeForm.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'

    const props = defineProps({
        company: {
            type: Object as PropType<Company>,
            required: true,
        },
    })

    const apiFormRef = ref<ApiFormRefType>(null)
    const urlFactory = new UrlFactory()
</script>
